module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Incoming-box-853efd5018598bd4cbb86244fc6c381c.svg";